import { Checkbox, Dialog, DialogFooter } from "@fluentui/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import {
  reportDocumentRoutine,
  setReportDocumentDialog,
} from "../../../../store/recommendationPage";
import { StyledPrimaryButton } from "../../../../components/styled";
import { FormSpinner } from "../../../../components/FormSpinner";
import { useSelector } from "../../../../store/hooks";

export const ReportDocumentDialog = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [generatePDF, setGeneratePDF] = useState(false);

  const isLoading = useSelector(
    (s) => s.recommendationPage.reportDocumentLoadStatus === "loading",
  );
  const reportDocument = useSelector(
    (s) => s.recommendationPage.reportDocument,
  );
  const close = () => {
    dispatch(
      setReportDocumentDialog({
        isOpen: false,
      }),
    );
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        showCloseButton: true,
        title: t("ram.reportDocumentDialog.label"),
      }}
      onDismiss={close}
      maxWidth={1500}
    >
      {t("ram.reportDocumentDialogText.label")}
      <div style={{ marginTop: 16 }}>
        <Checkbox
          label={t("ram.locationList.generatePDF")}
          checked={generatePDF}
          onChange={(_, checked) => setGeneratePDF(checked ?? false)}
        />
      </div>
      <DialogFooter>
        {reportDocument !== null ? (
          <StyledPrimaryButton
            iconProps={{ iconName: "Download" }}
            text={t("ram.reportDocumentDialogDownload.label")}
            onClick={() => {
              window.open(reportDocument.url, "_blank");
              close();
            }}
          />
        ) : (
          <StyledPrimaryButton
            iconProps={{ iconName: "TextDocument" }}
            text={t("ram.reportDocumentDialogGenerate.label")}
            onClick={() => {
              dispatch(reportDocumentRoutine.trigger({ generatePDF }));
            }}
            disabled={isLoading}
          />
        )}
      </DialogFooter>
      {isLoading && <FormSpinner />}
    </Dialog>
  );
};
